import validate from "/usr/src/app/content/n3-promos-8da93b7f-eabc-42f8-8fe8-0fa76c22a92b/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-promos-8da93b7f-eabc-42f8-8fe8-0fa76c22a92b/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}